import { render, staticRenderFns } from "./ItemEditTemplate.vue?vue&type=template&id=e317e48c&"
import script from "./ItemEditTemplate.vue?vue&type=script&lang=js&"
export * from "./ItemEditTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports